<div class="card" *ngIf="!selectedWorkload">
  <h5 class="card-header">
    <div class="flex-between">
      <div>WAFR</div>
      <div class="flex-start">
        <button class="btn btn-light m-0" (click)="load()">
          <i class="fa fa-refresh"></i>
          Refresh
        </button>
        <button class="btn btn-primary-soft m-0" (click)="openCreateWorkloadModal()">
          <i class="fa fa-plus" aria-hidden="true"></i> Create Workload
        </button>
      </div>
    </div>
  </h5>
  <div class="card-body flow-auto">
    <div class="alert alert-danger" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <table class="table table-docs table-hover">
      <thead>
        <tr>
          <th>Sl. No.</th>
          <th>Owner</th>
          <th>Name</th>
          <th>Created At</th>
          <th>Updated At</th>
          <th>Status</th>
          <th>Score</th>
          <th>Answered</th>
          <th>High Risk</th>
          <th>Medium Risk</th>
          <th>Error</th>
        </tr>
      </thead>
      <tbody *ngIf="workloads.length > 0">
        <tr *ngFor="let workload of workloads; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ workload.user_id }}</td>
          <td>
            <span class="nav-link cursor-pointer p-0" (click)="openWorkloadSummary(workload)">
              {{ workload.workload_name }}
            </span>
          </td>
          <td>{{ workload.created_at_label }}</td>
          <td>{{ workload.updated_at_label }}</td>
          <td>
            <div class="status-wrap">
              <img
                *ngIf="isRunningStatus(workload.status)"
                src="assets/img/loading_2.svg"
                alt="loading scans"
                class="status-loader"
              />
              <span class="status-pill" [ngClass]="getStatusClass(workload.status)">
                {{ workload.status }}
              </span>
            </div>
          </td>
          <td>{{ workload.overall_score_label }}</td>
          <td>{{ workload.answered_label }}</td>
          <td>{{ workload.high_risk_count }}</td>
          <td>{{ workload.medium_risk_count }}</td>
          <td class="error-cell" [title]="workload.last_error">
            {{ workload.last_error }}
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!loading && workloads.length === 0">
        <tr>
          <td colspan="11" class="text-center">No Workloads found</td>
        </tr>
      </tbody>
      <tbody *ngIf="loading">
        <tr>
          <td colspan="11" class="text-center">
            <img src="assets/img/loading_2.svg" alt="loading scans" class="loader-icon" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-azure-wafr-workload-summary
  *ngIf="selectedWorkload && !selectedLens"
  [selectedWorkload]="selectedWorkload"
  [workloadSummary]="workloadSummary"
  [workloadSummaryLoading]="workloadSummaryLoading"
  [workloadSummaryError]="workloadSummaryError"
  (back)="backToWorkloads()"
  (refresh)="loadWorkloadSummary(selectedWorkload)"
  (openLens)="openLens($event)"
></app-azure-wafr-workload-summary>

<app-azure-wafr-pillars
  *ngIf="selectedWorkload && selectedLens && !selectedPillar"
  [selectedLens]="selectedLens"
  [pillars]="pillars"
  [pillarsLoading]="pillarsLoading"
  [pillarsError]="pillarsError"
  (back)="backToLenses()"
  (refresh)="loadPillars()"
  (openPillar)="openPillar($event)"
></app-azure-wafr-pillars>

<app-azure-wafr-questions-answers
  *ngIf="selectedWorkload && selectedLens && selectedPillar"
  [selectedWorkload]="selectedWorkload"
  [selectedPillar]="selectedPillar"
  [pillars]="pillars"
  [pillarsLoading]="pillarsLoading"
  (back)="backToPillars()"
  (openPillar)="openPillar($event)"
  (answerSaved)="onQuestionAnswerSaved($event)"
></app-azure-wafr-questions-answers>

<div class="confirmContainer" *ngIf="showCreateWorkloadModal">
  <div class="confirmBox">
    <div class="KBHeader">Create Workload</div>
    <div class="KBBody">
      <div class="col-mb-6 mb-15">
        <label>Subscription ID:</label>
        <span>{{ createSubscriptionId || "-" }}</span>
      </div>

      <div class="col-mb-6 mb-15">
        <label>User ID:</label>
        <span>{{ createUserId || "-" }}</span>
      </div>

      <div class="col-mb-6 mb-15">
        <label>Workload Name<span class="required">*</span>:</label>
        <span>
          <div class="input-info">A unique identifier for the workload</div>
          <input
            autocomplete="off"
            class="form-control custom-input"
            type="text"
            [(ngModel)]="newWorkloadName"
            [ngClass]="{ 'error-text': workloadNameError }"
            maxlength="100"
            (ngModelChange)="workloadNameError = false; createErrorMessage = null"
            (keydown.enter)="createWorkload()"
          />
          <div class="input-info">
            The name must be from 3 to 100 characters. At least 3 characters must be
            non-whitespace. {{ 100 - newWorkloadName.trim().length }} characters remaining
          </div>
        </span>
      </div>

      <div *ngIf="createErrorMessage" class="error-message">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ createErrorMessage }}
      </div>
    </div>

    <div class="KBActions">
      <button class="btn btn-success" *ngIf="!createWorkloadLoading" (click)="createWorkload()">
        Create
      </button>
      <button class="btn btn-success" *ngIf="createWorkloadLoading" [attr.disabled]="true">
        <img src="assets/img/loading_2.svg" alt="loading scans" class="loading-btn-icon" />
        Create
      </button>
      <button class="btn btn-light" (click)="closeCreateWorkloadModal()">Cancel</button>
    </div>
  </div>
</div>
